// extracted by mini-css-extract-plugin
module.exports = {"container":"TextInput_container__1mE3S","fullWidth":"TextInput_fullWidth__2D8lC"};